import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { CallBackService } from '../services/CallBack.service';
import { AuthService } from '../../authmanagement/services/Auth.service';

@Component({
  selector: 'app-callbackPage',
  templateUrl: './callbackPage.component.html',
  styleUrls: ['./callbackPage.component.css']
})
export class CallbackPageComponent implements OnInit {

  error : boolean = false;

  constructor(private callbackService: CallBackService,
    private authService: AuthService,
    private router: Router,) { }

  ngOnInit(): void {
    try{
      // this.updateToDefault().then((data: any) => {
      //   if (data.isSuccess) {
      //     this.callbackService.dataCallback().then((data: any) => {
      //       this.router.navigate(["/unifiedMap"]);
      //     });
      //   }else{
      //     this.error = true;
      //     setTimeout(() => {
      //       let resp = this.authService.Logout();
      //     }, 4000);
      //   }
      // });

      this.callbackService.dataCallbackOneCall(true).then((data: any) => {
        this.router.navigate(["/unifiedMap"]);
      });
      
    }
    catch(e){
      console.log(e);
      this.error = true;
      setTimeout(() => {
        let resp = this.authService.Logout();
      }, 4000);
      
    }
  }

  ngOnDestroy(): void {
  }

  async updateToDefault(){
    return await firstValueFrom(this.authService.UpdateDefaultClientId());
  }

}
